// extracted by css-extract-rspack-plugin
export default {"Box":"StickyLinesHeader-module__Box__LVvtT","Box_1":"StickyLinesHeader-module__Box_1__IFVoy"};